exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label .anticon {\n  margin-left: 5px;\n}\n.last-modification {\n  margin-left: 5px;\n}\n", ""]);

// exports
